import {IPluginsDataResponse} from "@hooks/plugins/IPluginsDataResponse";
import {IProcessedPluginData, IProcessedPluginsData} from "@hooks/plugins/IProcessedPluginsData";
import {Plugin} from "@hooks/plugins/plugin";

export class Plugins {

    static processApiResponse(apiResponse: IPluginsDataResponse, nowMs?: number): IProcessedPluginsData {

        const plugins: IProcessedPluginData[] = apiResponse.data.plugins.map((plugin) => Plugin.processApiResponse(plugin, nowMs));

        return {
            plugins: plugins,
            current_page: apiResponse.data.current_page,
            total_plugins: apiResponse.data.total_plugins,
            plugins_per_page: apiResponse.data.plugins_per_page,
            total_pages: apiResponse.data.total_pages,
        };
    }
}
